module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.vendors), function(vendor) {
    return _c('div', {
      key: vendor.name,
      staticClass: "col-md-6 col-xl-3"
    }, [_c('dropshipment-widget', {
      attrs: {
        "vendor": vendor
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-share mr-5"
  }), _vm._v(" Dropshipment kanalen\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9aa58538","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dropshipment/DropshipmentPage.vue
// module id = 746
// module chunks = 1